'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signoutRedirect = exports.signinRedirect = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _OidcUserManager = require('../services/OidcUserManager');

var _Store = require('../services/Store');

var _Store2 = _interopRequireDefault(_Store);

var _CwLog = require('../services/CwLog');

var _CwLog2 = _interopRequireDefault(_CwLog);

var _OidcErrorAction = require('../components/oidc/actions/OidcErrorAction');

var _OidcErrorAction2 = _interopRequireDefault(_OidcErrorAction);

var _ModuleEventBusService = require('../services/ModuleEventBusService');

var _ScreenKeyConst = require('../components/screen/ScreenKeyConst');

var _OidcRedirectingAction = require('../components/oidc/actions/OidcRedirectingAction');

var _OidcRedirectingAction2 = _interopRequireDefault(_OidcRedirectingAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var errorCallback = function errorCallback(error) {
  _CwLog2.default.error('Error handling the OIDC request: ' + error.message);
  (0, _Store2.default)().dispatch((0, _OidcErrorAction2.default)(error.message));
};

var signIn = function signIn() {
  var custom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

  // preserve current url to redirect back to after signin redirect callback
  (0, _OidcUserManager.userManager)().signinRedirect((0, _assign2.default)({ data: { redirectUrl: window.location.pathname + window.location.search + window.location.hash } }, custom)).catch(errorCallback);
};

var signOut = function signOut() {
  (0, _OidcUserManager.userManager)().signoutRedirect().catch(errorCallback);
};

var signinRedirect = exports.signinRedirect = function signinRedirect() {
  var custom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

  (0, _Store2.default)().dispatch((0, _OidcRedirectingAction2.default)(true));
  signIn(custom);
};

var signoutRedirect = exports.signoutRedirect = function signoutRedirect() {
  (0, _Store2.default)().dispatch((0, _OidcRedirectingAction2.default)(true));
  signOut();
};

// auto subscribe to module event bus events from modulereducer (avoids circular dependency)
// call functions that do not dispatch to store since events are published from reducer
(0, _ModuleEventBusService.subscribe)('USER_EXPIRED', signIn, undefined, _ScreenKeyConst.MODULE_SCREEN_KEY);
(0, _ModuleEventBusService.subscribe)('USER_SIGNED_OUT', signOut, undefined, _ScreenKeyConst.MODULE_SCREEN_KEY);


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/OidcRedirectService.js
// module id = 817
// module chunks = 10